function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import cn from 'classnames';
import React, { FC, HTMLAttributes } from 'react';
import { Title } from '../../Title';
require("./ProductBadge.css");
var styles = {
  "Root": "ProductBadge-module-Root_3U_"
};
export const ProductBadge = ({
  color = '#FF1F78',
  top,
  bottom,
  left,
  right,
  ...rest
}) => {
  const style = {
    backgroundColor: color,
    top: top ? 0 : 'auto',
    bottom: bottom ? 0 : 'auto',
    left: left ? 0 : 'auto',
    right: right ? 0 : 'auto'
  };
  return /*#__PURE__*/React.createElement(Title, _extends({}, rest, {
    tag: "h6",
    style: style,
    className: cn(styles.Root)
  }));
};